import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import UserNavbar from "../../components/user/userNavbar";
import styles from "../../components/tradeall.module.css";
import { LineWave } from "react-loader-spinner";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { HiOutlineZoomOut } from "react-icons/hi";
import { HiOutlineZoomIn } from "react-icons/hi";
import reset_icon from "../../assets/circular.png";
import reduce_icon from "../../assets/minimize.png";
import { IoArrowBack } from "react-icons/io5";
import crossicon from "../../assets/cross.png";
const Userbuysell = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [modalloading, setModalLoading] = useState(false);
  // const [loadingSell, setLoadingSell] = useState(false);

  const [iframeHeight1, setIframeHeight1] = useState("38vh");
  const [iframeHeight2, setIframeHeight2] = useState("38vh");
  // const [iframeHeight3, setIframeHeight3] = useState("38vh");

  const [iframeHeight4, setIframeHeight4] = useState("38vh");
  const [iframeHeight5, setIframeHeight5] = useState("38vh");
  const [iframeHeight6, setIframeHeight6] = useState("38vh");

  const [latestevent, setLatestevent] = useState([]);
  const [lookupdata, setLookupdata] = useState([]);
  const [iframeSrc, setIframeSrc] = useState(
    "https://www.ig.com/content/dam/publicsites/dev/mt4/MT4_WEB.html"
  );
  const [showModal, setShowModal] = useState(false);
  const [newSrc, setNewSrc] = useState("");
  const [portfolioBalance, setPortfolioBalance] = useState("");
  const [profitTarget, setprofitTarget] = useState("");
  const [lossLimit, setlossLimit] = useState("");

  const [currenctprize2, setCurrenctprize2] = useState("");
  const currencies = ["CHF", "AUD", "GBP", "USD", "CAD", "JPY", "NZD", "EUR"];
  const currencySymbols = {
    CHF: "CHF",
    AUD: "A$",
    GBP: "£",
    USD: "$",
    CAD: "C$",
    JPY: "¥",
    NZD: "NZ$",
    EUR: "€",
  };
  const allPairs = [
    "AUD/CAD",
    "AUD/JPY",
    "AUD/NZD",
    "AUD/USD",
    "CAD/CHF",
    "CAD/JPY",
    "CHF/JPY",
    "EUR/AUD",
    "EUR/CAD",
    "EUR/CHF",
    "EUR/GBP",
    "EUR/JPY",
    "EUR/NZD",
    "EUR/USD",
    "GBP/AUD",
    "GBP/CAD",
    "GBP/CHF",
    "GBP/JPY",
    "GBP/NZD",
    "GBP/USD",
    "NZD/CAD",
    "NZD/CHF",
    "NZD/JPY",
    "NZD/USD",
    "USD/CAD",
    "USD/CHF",
    "USD/JPY",
  ];

  const all_lottypes = ["Standard (100000)", "Mini (10000)", "Micro (1000)"];
  const marginRatios = [
    "5:1",
    "10:1",
    "20:1",
    "25:1",
    "30:1",
    "40:1",
    "50:1",
    "75:1",
    "100:1",
    "125:1",
    "150:1",
    "200:1",
    "300:1",
    "400:1",
    "500:1",
    "1000:1",
  ];

  const allCurrencyPairs = [
    "GBPUSD",
    "GBPJPY",
    "GBPNZD",
    "EURGBP",
    "GBPCHF",
    "GBPAUD",
    "GBPCAD",
    "USDJPY",
    "NZDUSD",
    "EURUSD",
    "USDCHF",
    "AUDUSD",
    "USDCAD",
    "NZDJPY",
    "EURJPY",
    "CHFJPY",
    "AUDJPY",
    "CADJPY",
    "NZDCAD",
    "EURCAD",
    "CADCHF",
    "AUDCAD",
    "NZDCHF",
    "EURCHF",
    "EURAUD",
    "AUDNZD",
    "EURNZD",
  ];

  const [prepopulateMargindata, setPrepopulateMargindata] = useState("");
  const [accountCurrency, setAccountCurrency] = useState("");
  const [currencyPair, setCurrencyPair] = useState("");
  const [tradeSize, setTradeSize] = useState("");
  const [marginRatio, setMarginRatio] = useState("");
  const [maxLots, setMaxLots] = useState("");

  const [minimumLotSize, setminimumLotSize] = useState("");
  const [lotType, setLotType] = useState("");
  const [currencyUnits, setCurrencyUnits] = useState("");
  const [profitTargetPips, setprofitTargetPips] = useState("");
  const [lossLimitPips, setlossLimitPips] = useState("");

  const [currenctprize, setCurrenctprize] = useState("");

  const [currenctprize_forsamecurrency, setCurrenctprize_forsamecurrency] =
    useState("");
  const [finalmarginvalue, setFinalmarginvalue] = useState("");

  const [isVisible, setIsVisible] = useState(true);
  const [isVisible2, setIsVisible2] = useState(true);
  const [isVisible3, setIsVisible3] = useState(true);
  const [isVisible4, setIsVisible4] = useState(true);
  const [isVisible6, setIsVisible6] = useState(true);
  const [accountCurrency2, setAccountCurrency2] = useState("");
  const [tradeSize2, setTradeSize2] = useState("");

  const [finalPipvalue, setFinalPipvalue] = useState("");
  const [livetradeTime, setlivetradeTime] = useState("");
  const [livetradeTime_forsamecurrency, setlivetradeTime_forsamecurrency] =
    useState("");
  const [errorForEstimateandPrevious, setErrorForEstimateandPrevious] =
    useState("");

  const PipValueCalculate = (pipDecimal) => {
    if (!accountCurrency || !currencyPair) return "";
    //  console.log("hi i ma in pip calculatore")
    const derivedPair = getDerivedPair();
    // console.log("derivedPair" , derivedPair)

    let derivedBase = "",
      derivedQuote = "";
    if (derivedPair.includes("/")) {
      [derivedBase, derivedQuote] = derivedPair.split("/");
    } else {
      derivedBase = derivedPair.slice(0, 3);
      derivedQuote = derivedPair.slice(3);
    }
    const [base, quote] = currencyPair.split("/"); // Extract base and quote for the currency pair
    let pipValue = null;

    // Case 1: Account currency is in the denominator
    if (accountCurrency === derivedQuote) {
      if (accountCurrency != quote && accountCurrency != base) {
        pipValue =
          (pipDecimal / currenctprize_forsamecurrency) *
          currencyUnits *
          currenctprize;
      }
    }

    // Case 2: Account currency is in the numerator
    if (accountCurrency === derivedBase) {
      if (accountCurrency != quote && accountCurrency != base) {
        pipValue =
          ((pipDecimal / currenctprize_forsamecurrency) * currencyUnits) /
          currenctprize;
        // console.log("hi ashi i am in 2" , pipValue)
      }
    }
    //Case 3 - Account currency is in numerator
    if (accountCurrency === derivedBase || accountCurrency === derivedQuote) {
      if (accountCurrency === base) {
        pipValue = (pipDecimal / (1 / currenctprize)) * currencyUnits;
      }
    }
    //Case 4 - Account currency is in denominators
    if (accountCurrency === derivedQuote || accountCurrency === derivedBase) {
      if (accountCurrency === quote) {
        pipValue = (pipDecimal / currenctprize) * currencyUnits * currenctprize;
      }
    }

    if (pipValue !== null) {
      setFinalPipvalue(pipValue.toFixed(3));
    } else {
      setFinalPipvalue(null);
    }

    return pipValue;
  };

  const findMarginCalculator = () => {
    if (!tradeSize || !currenctprize || !marginRatio || !currencyPair) {
      return;
    }

    const leverage = parseFloat(marginRatio.split(":")[0]); // Extract leverage value
    const tradeSizeValue = parseFloat(tradeSize);
    const currentPriceValue = parseFloat(currenctprize);

    if (isNaN(leverage) || isNaN(tradeSizeValue) || isNaN(currentPriceValue)) {
      toast.error("Please enter valid numeric values!", {
        position: "top-right",
      });
      return;
    }

    const derivedPair = getDerivedPair();
    let derivedBase = "",
      derivedQuote = "";
    if (derivedPair.includes("/")) {
      [derivedBase, derivedQuote] = derivedPair.split("/");
    } else {
      derivedBase = derivedPair.slice(0, 3);
      derivedQuote = derivedPair.slice(3);
    }
    const [base, quote] = currencyPair.split("/");

    let marginRequired;
    //  <--num-->

    if (accountCurrency === base) {
      marginRequired = (currencyUnits / leverage) * 1;
    } else if (accountCurrency === quote) {
      marginRequired = (currencyUnits / leverage) * currentPriceValue;
    } else {
      marginRequired = (currencyUnits * currentPriceValue) / leverage;
    }

    setFinalmarginvalue(marginRequired);
  };

  useEffect(() => {
    findMarginCalculator();
  }, [
    currenctprize_forsamecurrency,
    minimumLotSize,
    currenctprize,
    currencyPair,
    currencyUnits,
    marginRatio,
    tradeSize,
  ]);

  const handleCalculate = async () => {
    if (finalPipvalue && finalmarginvalue) {
      saveMarginCalculatordata();
    }
  };

  useEffect(() => {
    let pipDecimal;
    if (currencyPair.includes("JPY")) {
      pipDecimal = 0.01;
    } else {
      pipDecimal = 0.0001;
    }

    PipValueCalculate(pipDecimal);
  }, [
    currencyUnits,
    currenctprize_forsamecurrency,
    minimumLotSize,
    currenctprize,
    currencyPair,
  ]);

  const saveMarginCalculatordata = async () => {
    setModalLoading(false);
    try {
      const userid = localStorage.getItem("userregisterId");

      if (
        !accountCurrency ||
        !currencyPair ||
        !tradeSize ||
        !marginRatio ||
        !currenctprize ||
        !finalmarginvalue ||
        !finalPipvalue ||
        !portfolioBalance ||
        !profitTarget ||
        !lossLimit ||
        !lotType ||
        !currencyUnits ||
        !profitTargetPips ||
        !lossLimitPips ||
        !maxLots ||
        !minimumLotSize
      ) {
        toast.warning(`Please fill all inputs to save !`, {
          position: "top-right",
        });
        setModalLoading(false);
        return;
      }
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/user/savedmarginCalculatordata/${userid}`,
        {
          accountCurrency,
          currencyPair,
          tradeSize,
          marginRatio,
          currenctprize,
          finalmarginvalue,
          finalPipvalue,
          portfolioBalance,
          profitTarget,
          lossLimit,
          lotType,
          currencyUnits,
          profitTargetPips,
          lossLimitPips,
          maxLots,
          minimumLotSize,
        }
      );

      toast.success("Data saved successfully!", {
        position: "top-right",
      });
      setModalLoading(false);
    } catch (error) {
      console.error("Error posting data:", error);
      toast.error(`Error in saving data !`, {
        position: "top-right",
      });
      setModalLoading(false);
    }
  };

  const livecurrenctprice = async (currency) => {
    try {
      const live_currency_name = currency;

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/user/get_currenctpriceforCalculator`,
        { live_currency_name }
      );

      let finalprice;
      let p1;
      if (response.data.note) {
        p1 = response.data.getliveprice;
        finalprice = (1 / p1?.ap).toFixed(3);
      } else {
        p1 = response.data.getliveprice;
        finalprice = p1?.ap; // Check if `ap` exists
      }

      const finalpriceTime = p1?.updatedAt;
      let formattedDate = "Time not available";
      if (finalpriceTime) {
        const dateObject = new Date(finalpriceTime); // Ensure it's a Date object
        if (!isNaN(dateObject)) {
          // Check if it's a valid date
          formattedDate =
            dateObject
              .toISOString()
              .slice(0, 10)
              .split("-")
              .reverse()
              .join("-") +
            " " +
            " , " +
            dateObject.toISOString().slice(11, 19);
        }
      }

      if (response.status === 200) {
        setCurrenctprize(finalprice || "Price not available");
        setlivetradeTime(formattedDate || "Time not available");
      } else {
        // setLiveprice(""); // Handle other non-200 cases gracefully
        setCurrenctprize("");
        setlivetradeTime("");
      }
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 404) {
        // setLiveprice("");
        setCurrenctprize("");
        setlivetradeTime("");

        toast.error("Currency not found in backend", { position: "top-right" });
      } else {
        toast.error("Failed to fetch current price", { position: "top-right" });
      }
    }
  };

  const livecurrenctprice_ofsamecurrency = async (same_currency) => {
    try {
      const live_samecurrency_name = same_currency;

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/user/get_currenctpriceforCalculatorforsamecurrency`,
        { live_samecurrency_name }
      );

      let finalprice;
      let p1;
      if (response.data.note) {
        p1 = response.data.getliveprice;
        finalprice = (1 / p1?.ap).toFixed(3);
      } else {
        p1 = response.data.getliveprice;
        finalprice = p1?.ap;
      }

      const finalpriceTime = p1?.updatedAt;
      let formattedDate = "Time not available";
      if (finalpriceTime) {
        const dateObject = new Date(finalpriceTime); // Ensure it's a Date object
        if (!isNaN(dateObject)) {
          // Check if it's a valid date
          formattedDate =
            dateObject
              .toISOString()
              .slice(0, 10)
              .split("-")
              .reverse()
              .join("-") +
            " " +
            " , " +
            dateObject.toISOString().slice(11, 19);
        }
      }

      if (response.status === 200) {
        setCurrenctprize_forsamecurrency(finalprice || "Price not available");
        setlivetradeTime_forsamecurrency(formattedDate || "Time not available");
      } else {
        setCurrenctprize_forsamecurrency("");
        setlivetradeTime_forsamecurrency("");
      }
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 404) {
        setCurrenctprize_forsamecurrency("");
        setlivetradeTime_forsamecurrency("");

        toast.error("Currency not found in backend", { position: "top-right" });
      } else {
        toast.error("Failed to fetch current price", { position: "top-right" });
      }
    }
  };

  const getDerivedPair = () => {
    if (!accountCurrency || !currencyPair) return "";

    const [base, quote] = currencyPair.split("/");

    if (accountCurrency === base) {
      const derivedPair = `${quote}/${accountCurrency}`;
      livecurrenctprice(derivedPair.replace("/", "")); // Fetch live price if necessary
      livecurrenctprice_ofsamecurrency(currencyPair.replace("/", ""));
      return derivedPair;
    }

    if (accountCurrency === quote) {
      const derivedPair = `${base}/${accountCurrency}`;
      livecurrenctprice(derivedPair.replace("/", ""));
      livecurrenctprice_ofsamecurrency(currencyPair.replace("/", ""));
      return derivedPair;
    }
    const derivedPair = `${base}${accountCurrency}`;
    livecurrenctprice(derivedPair);
    livecurrenctprice_ofsamecurrency(currencyPair.replace("/", ""));
    return derivedPair;
  };

  const modalRef = useRef(null);

  const handleOpenModal = async() => {
    setShowModal(true);
    const response = await axios.get(`${process.env.REACT_APP_URL}/user/getwebsocket_currentprice`)
    // console.log("response" , response)
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const sendIframeurlToBackend = async () => {
    try {
      const userid = localStorage.getItem("userregisterId");
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/user/sendIframeUrltodb/${userid}`,
        { newSrc }
      );
    } catch (error) {
      console.log("error", error);
      toast.error("Error in saving Url to Backend", { position: "top-right" });
    }
  };

  const getIframeUrl = async () => {
    try {
      const userid = localStorage.getItem("userregisterId");
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/user/getIframeUrlFromDb/${userid}`
      );
      if (response.data.iframe_url) {
        setNewSrc(response.data.iframe_url);
      }
    } catch (error) {
      console.error("Error fetching URL:", error);
    }
  };

  useEffect(() => {
    getIframeUrl();
  }, []);
  const findCurrenyUnits = () => {
    const lotTypeValues = {
      "Standard (100000)": 100000,
      "Mini (10000)": 10000,
      "Micro (1000)": 1000,
    };

    if (tradeSize && lotType && lotTypeValues[lotType]) {
      setCurrencyUnits(tradeSize * lotTypeValues[lotType]);
    } else {
      setCurrencyUnits("");
    }
  };

  const ProfitTargetUnits = () => {
    if (finalPipvalue && portfolioBalance && profitTarget && currencyUnits) {
      const data = (
        (portfolioBalance * profitTarget) /
        (finalPipvalue * currencyUnits)
      ).toFixed(4);
      setprofitTargetPips(data);
    } else {
      setprofitTargetPips("");
    }
  };

  const LossTargetUnits = () => {
    if (finalPipvalue && portfolioBalance && lossLimit && currencyUnits) {
      const losstargetvalue = (
        (portfolioBalance * lossLimit) /
        (finalPipvalue * currencyUnits)
      ).toFixed(4);
      setlossLimitPips(losstargetvalue);
    } else {
      setlossLimitPips("");
    }
  };

  const findmaxLots = () => {
    if (finalmarginvalue && portfolioBalance) {
      setMaxLots((portfolioBalance / finalmarginvalue).toFixed(4));
    } else {
      setMaxLots("");
    }
  };
  useEffect(() => {
    findmaxLots();
  }, [
    portfolioBalance,
    finalmarginvalue,
    finalPipvalue,
    profitTarget,
    lossLimit,
    lotType,
  ]);

  useEffect(() => {
    findCurrenyUnits();
  }, [lotType, tradeSize]);

  useEffect(() => {
    ProfitTargetUnits();
    LossTargetUnits();
  }, [portfolioBalance, finalPipvalue, currencyUnits, profitTarget, lossLimit]);

  const handleSubmit = async () => {
    await sendIframeurlToBackend();
    setIframeSrc(newSrc);
    handleCloseModal();
  };

  // <----aashima---->
  const fetchlatest_event = async () => {
    try {
      const userid = localStorage.getItem("userregisterId");
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/user/getlivetrade_upcomingdata/${userid}`
      );
      if (response.data.status === 200) {
        const future_data = response.data?.futureEvents;
        const futureeventdata = future_data?.map((item) => item).flat();

        if (futureeventdata.length > 0) {
          setLatestevent(futureeventdata);

          setLoading(false);
        } else {
          // console.log("No future events found");
          setLoading(false);
          setLatestevent([]);
        }
      } else {
        setLatestevent([]);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching messages:", error);
    }
  };
  const [lookupdata2, setLookupdata2] = useState([]);
  const fetchlookup_result = async () => {
    try {
      const userid = localStorage.getItem("userregisterId");
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/user/getlivetrade_lookuptabledata/${userid}`
      );

      if (response.data.status === 200) {
        const future_data = response.data?.futureEvents;
        const invalid_data = response.data?.invalidEvents || [];

        const futureeventdata = Array.isArray(future_data)
          ? future_data.flat()
          : [];
        const invalidEventData = Array.isArray(invalid_data)
          ? invalid_data.flat()
          : [];
        const finalComments = futureeventdata.map((item) => item.finalComment);

        const finalComments_forinvalidData = invalidEventData.map((item) => {
          return item.reason;
        });

        if (futureeventdata.length > 0) {
          setLookupdata(finalComments);

          setLookupdata2(finalComments_forinvalidData);
          setLoading(false);
        } else {
          // console.log("No future events found");
          setLoading(false);
          setLatestevent([]);
        }
      } else {
        setLatestevent([]);
        setLoading(false);
        setLookupdata([]);
      }
    } catch (error) {
      setLoading(false);
      setLookupdata([]);
      console.error("Error fetching messages:", error);
    }
  };

  useEffect(() => {
    fetchlatest_event();
    fetchlookup_result();
  }, []);

  const [currency_Iframe_Investing, setCurrency_Iframe_Investing] = useState(
    []
  );
  const find_currencyForIframe = () => {
    const response = [...new Set(latestevent.map((item) => item.country))];
    // console.log("response", response);
    setCurrency_Iframe_Investing(response);
  };

  useEffect(() => {
    find_currencyForIframe();
  }, [lookupdata]);

  const handleClickOutside = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      handleCloseModal();
    }
  };
  const Closemodal = () => {
    handleCloseModal();
  };

  const getmargindataandpopulate = async () => {
    try {
      const userid = localStorage.getItem("userregisterId");

      const get_response = await axios.get(
        `${process.env.REACT_APP_URL}/user/getmaginCalculatorDataandprepopulate/${userid}`
      );

      const response1 = get_response.data;
      const getMarginData = response1.getuser[0];
      setPrepopulateMargindata(getMarginData);

      //  console.log("getMarginData" , getMarginData)
      //  toast.success("Data fetched successfully!", {
      //   position: "top-right",
      // });
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error(`Error in fetching data !`, {
        position: "top-right",
      });
    }
  };

  useEffect(() => {
    getmargindataandpopulate();
  }, []);

  const matchPopulatedata = () => {
    if (prepopulateMargindata) {
      setAccountCurrency(prepopulateMargindata.accountCurrency);
      setMarginRatio(prepopulateMargindata.marginRatio);
      setTradeSize(prepopulateMargindata.tradeSize);
      setminimumLotSize(prepopulateMargindata.minimumLotSize);
      setCurrencyPair(prepopulateMargindata.currencyPair);
      setLotType(prepopulateMargindata.lotType);
      setCurrenctprize(prepopulateMargindata.currenctprize);
      setCurrencyUnits(prepopulateMargindata.currencyUnits);
      setPortfolioBalance(prepopulateMargindata.portfolioBalance);
      setprofitTarget(prepopulateMargindata.profitTarget);
      setprofitTargetPips(prepopulateMargindata.profitTargetPips);
      setMaxLots(prepopulateMargindata.maxLots);
      setFinalmarginvalue(prepopulateMargindata.finalmarginvalue);
      setFinalPipvalue(prepopulateMargindata.finalPipvalue);
      setlossLimit(prepopulateMargindata.lossLimit);
      setlossLimitPips(prepopulateMargindata.lossLimitPips);
    }
  };
  useEffect(() => {
    matchPopulatedata();
  }, [prepopulateMargindata]);

  const [scale, setScale] = useState(1); // Initial zoom level
  const [scale2, setScale2] = useState(1); // Initial zoom level
  const [scale3, setScale3] = useState(1);
  const [scale4, setScale4] = useState(1);
  const [scale6, setScale6] = useState(1);

  const zoomIn = () => setScale((prevScale) => Math.min(prevScale + 0.1, 3)); // Max zoom level
  const zoomOut = () => setScale((prevScale) => Math.max(prevScale - 0.1, 0.5)); // Min zoom level// useEffect(() => {

  const zoomIn2 = () => setScale2((prevScale) => Math.min(prevScale + 0.1, 3)); // Max zoom level
  const zoomOut2 = () =>
    setScale2((prevScale) => Math.max(prevScale - 0.1, 0.5)); // Min zoom level// useEffect(() => {

  const zoomIn3 = () => setScale3((prevScale) => Math.min(prevScale + 0.1, 3)); // Max zoom level
  const zoomOut3 = () =>
    setScale3((prevScale) => Math.max(prevScale - 0.1, 0.5)); // Min zoom level// useEffect(() => {

  const zoomIn4 = () => setScale4((prevScale) => Math.min(prevScale + 0.1, 3)); // Max zoom level
  const zoomOut4 = () =>
    setScale4((prevScale) => Math.max(prevScale - 0.1, 0.5)); // Min zoom level// useEffect(() => {

  const zoomIn6 = () => setScale6((prevScale) => Math.min(prevScale + 0.1, 3)); // Max zoom level
  const zoomOut6 = () =>
    setScale6((prevScale) => Math.max(prevScale - 0.1, 0.5)); // Min zoom level// useEffect(() => {

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  const toggleVisibility2 = () => {
    setIsVisible2(!isVisible2);
  };
  const toggleVisibility3 = () => {
    setIsVisible3(!isVisible3);
  };
  const toggleVisibility4 = () => {
    setIsVisible4(!isVisible4);
  };
  const toggleVisibility6 = () => {
    setIsVisible6(!isVisible6);
  };

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden"; // Disable scrolling on the body
    } else {
      document.body.style.overflow = "auto"; // Re-enable scrolling
    }
    return () => {
      document.body.style.overflow = "auto"; // Clean up
    };
  }, [showModal]);

  const [prices, setPrices] = useState({});

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setShowModal(false);
      }
    };

    if (showModal) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [showModal]);

  const countryCodes = {
    US: 25,
    Canada: 6,
    UK: 72,
    NZ: 22,
    Australia: 17,
    Germany: 10,
    France: 35,
    Japan: 43,
    India: 12,
    China: 4,
    Brazil: 5,
  };

  return (
    <>
      {loading && (
        <div className="fixed top-[8%] text-center mb-2 flex items-center justify-center   w-full">
          <LineWave
            height="60"
            width="60"
            color="#111827"
            ariaLabel="bars-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            className=" w-10 h-10 flex items-center justify-center  mt-10 "
          />
        </div>
      )}
      <div>
        <UserNavbar />
      </div>

      <h1 className="flex items-center font-bold text-[18px] mt-[23%] sm:mt-[20%] md:mt-[12%] lg:mt-[10%] xl:mt-[7%] mx-[3%]">
        <IoArrowBack
          className="mr-2 cursor-pointer "
          onClick={() => navigate("/user/economicdata")}
          title="Back Button"
        />
        Future Trade Event:
      </h1>

      {latestevent.length === 0 ? (
        <div className={` m-2 mt-0 text-center font-semibold text-xl `}>
          Sorry!! No Future trades available .
        </div>
      ) : (
        <div className="overflow-auto mx-[2%]">
          <div className="overflow-x-auto overflow-y-auto  ">
            <table
              className={` ${styles.tableuser} min-w-full  rounded overflow-x-scroll m-auto text-[16px] font-semibold`}
            >
              <thead className="bg-[#D2C2F0]   text-[#240d3a]  sticky top-0 z-10 text-[16px] font-semibold border-b-[12px] border-solid border-[#F6F6F6] rounded-[8px]">
                <tr>
                  <th className=" sticky top-0 py-2 px-4">S. No.</th>
                  <th className=" sticky top-0 py-2 px-4">Date</th>
                  <th className=" sticky top-0 py-2 px-4">Time(GMT)</th>
                  <th className="sticky top-0 py-2 px-4">Country</th>
                  <th className="sticky top-0 py-2 px-4">Currency</th>
                  <th className="sticky top-0 py-2 px-4">Event</th>
                  <th className="sticky top-0 py-2 px-4">Previous</th>
                  <th className="sticky top-0 py-2 px-4">Estimate</th>
                  <th className="sticky top-0 py-2 px-4">Actual</th>
                  <th className="sticky top-0 py-2 px-4">Trade</th>
                  <th className="sticky top-0 py-2 px-4">Trade Grade</th>
                  <th className="sticky top-0 py-2 px-4">
                    Investing.com Var name
                  </th>

                  <th className="sticky top-0 py-2 px-4">
                    Trading Economics Var name
                  </th>
                  <th className="sticky top-0 py-2 px-4">
                    Non - Zero (Currency)
                  </th>
                  <th className="sticky top-0 py-2 px-4">
                    Non - Zero (Correlation)
                  </th>
                  <th className="sticky top-0 py-2 px-4">Flat (Currency)</th>
                  <th className="sticky top-0 py-2 px-4">Flat (Correlation)</th>
                  <th className="sticky top-0 py-2 px-4">Comments</th>
                </tr>
              </thead>
              <tbody className="bg-[#F6F6F6]  z-0 text-[#240d3a]">
                {latestevent
                  .sort((a, b) => new Date(b.date) - new Date(a.date))
                  .map((item, index) => (
                    <>
                      <tr
                        key={index}
                        className="text-center border-y-[12px] border-solid border-[#F6F6F6] bg-white hover:bg-[#D2C2F066]"
                      >
                        {/* { console.log("modalData" , modalData)} */}
                        <td className="py-2 px-4 min-w-[80px]">{index + 1}.</td>
                        <td className="py-2 px-4">{item.date}</td>
                        <td className="py-2 px-4">{item.time}</td>
                        <td className="py-2 px-4">{item.country}</td>
                        <td className="py-2 px-4">{item.currency}</td>
                        <td className="py-2 px-4 ml-[-5px] text-blue-500 cursor-pointer min-w-[200px] outline-none">
                          {item.event}
                        </td>
                        <td className="py-2 px-4 ml-[-5px] text-blue-500 cursor-pointer ">
                          {item.previous}
                        </td>
                        <td className="py-2 px-4 ml-[-5px] text-blue-500 cursor-pointer">
                          {item.estimate}
                        </td>
                        <td className="py-2 px-4 ml-[-5px] text-blue-500 cursor-pointer ">
                          {item.actual}
                        </td>

                        <td className="py-2 px-4">{item.trade}</td>
                        <td className="py-2 px-4">{item.trade_grade}</td>
                        <td className="py-2 px-4 min-w-[200px] outline-none">
                          {item.investing_name}
                        </td>

                        <td className="py-2 px-4 min-w-[200px] outline-none">
                          {item.trading_economics}
                        </td>
                        <td className="py-2 px-4">{item.movement_currency}</td>
                        <td className="py-2 px-4">
                          {item.movement_correlation}
                        </td>
                        <td className="py-2 px-4">{item.flat_currency}</td>
                        <td className="py-2 px-4">{item.flat_correlation}</td>
                        <td className="py-2 px-4 min-w-[200px] outline-none">
                          {item.comments}
                        </td>
                      </tr>
                    </>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <div className="flex justify-between items-start w-full flex-col sm:flex-col md:flex-row ml-[5%] sm:ml-[5%] md:ml-0">
        <div>
          {lookupdata.length > 0 ? (
            <div className="bg-[#dccafe5e] sm:w-[86vw] w-[86vw] md:w-[50vw] py-4 px-4 text-[#240d3a] font-bold mt-2 ml-[4%]">
              {lookupdata.map((item, index) => (
                <div
                  key={index}
                  className="mb-2 text-[16px] sm:text-[16px] md:text-[16px] xl:text-[20px]"
                >
                  {item.split(";").map((segment, segIndex) => {
                    const currency =
                      latestevent[index % latestevent.length]
                        ?.movement_currency;
                    return (
                      <div key={segIndex} className="mb-1">
                        {segment.split(/(Sell|Buy)/).map((part, idx) => {
                          if (part === "Sell") {
                            return (
                              <span
                                key={idx}
                                className="text-red-500 text-[16px] sm:text-[16px] md:text-[16px] xl:text-[20px]"
                              >
                                Currency pair ({currency}) expected to decrease
                              </span>
                            );
                          } else if (part === "Buy") {
                            return (
                              <span
                                key={idx}
                                className="text-green-500 text-[16px] sm:text-[16px] md:text-[16px] xl:text-[20px]"
                              >
                                Currency pair ({currency}) expected to increase
                              </span>
                            );
                          }
                          return part; // For other parts of the string (non-Sell/Buy)
                        })}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          ) : (
            <div></div>
          )}

          {lookupdata2.length > 0 ? (
            <div className="bg-[#dccafe5e] sm:w-[86vw] w-[86vw] md:w-[50vw] py-4 px-4 text-[#240d3a] font-bold mt-2 ml-[4%]">
              {lookupdata2.map((item, index) => (
                <p key={index}>{item}</p>
              ))}
            </div>
          ) : (
            <div></div>
          )}
        </div>

        <button
          onClick={handleOpenModal}
          className=" mt-4 px-4 py-1 bg-[#240D3A] text-white rounded-md mr-[3%] hover:bg-[#5a2989]"
        >
          Prepare For Trade
        </button>
      </div>

      <div className="flex justify-around items-center w-full flex-col sm:flex-col md:flex-col lg:flex-col xl:flex-row mt-[4%] ">
        <div>
          <div className="flex justify-around items-end w-[90vw] sm:w-[90vw] md:w-full">
            <div className="py-1 px-4 border border-gray-300 rounded">
              <div className="flex items-center space-x-2 cursor-pointer">
                <img
                  src={reduce_icon}
                  alt="reduce_icon"
                  className="h-[20px] w-[20px] mr-2 mt-1 font-bold "
                  onClick={() => setIframeHeight1("13vh")}
                  title="reduce height"
                />
                <img
                  src={reset_icon}
                  alt="reset_icon"
                  className="h-[20px] w-[20px] mr-2 mt-1 font-bold "
                  onClick={() => setIframeHeight1("38vh")}
                  title="reset height"
                />
              </div>
            </div>

            <div className="flex justify-center mt-3 space-x-4">
              <div className="py-1 px-4 border border-gray-300 rounded">
                <div className="flex items-center space-x-2">
                  <HiOutlineZoomIn
                    onClick={zoomIn}
                    className="cursor-pointer w-6 h-6"
                    title="zoomin"
                  />
                  <HiOutlineZoomOut
                    onClick={zoomOut}
                    className="cursor-pointer w-6 h-6"
                    title="zoomout"
                  />
                </div>
              </div>
              <button
                onClick={toggleVisibility}
                className=" px-4 py-1 bg-[#240D3A] text-white rounded hover:bg-[#5a2989] transition"
              >
                {isVisible ? "Hide" : "Unhide"}
              </button>
            </div>
          </div>
          {isVisible && (
            <div
              className="flex justify-center items-center mt-1 w-[95vw] sm:w-[95vw] md:w-[95vw] lg:w-[95vw] xl:w-[46vw]"
              style={{
                height: iframeHeight1, // Fixed container height
                overflow: "hidden", // Ensure no content spills outside
                position: "relative",
              }}
            >
              <iframe
                title="Trading economics"
                src="https://tradingeconomics.com/calendar"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen=""
                className=" block    border-[1px]  border-slate-300  sm:border-[0px]  w-[95vw] sm:w-[100vw] md:w-[100vw] lg:w-[100vw] xl:w-[46vw] rounded-2xl"
                style={{
                  width: "100%",
                  height: "100%",
                  transform: `scale(${scale}) translate(${
                    -((scale - 1) / scale) * 50
                  }%, ${-((scale - 1) / scale) * 50}%)`,
                  transformOrigin: "top left",
                }}
              ></iframe>
            </div>
          )}
        </div>

        <div>
          <div className="ml-[12%] sm:ml-[12%] md:ml-0 flex w-[90vw] sm:w-[90vw] md:w-[95vw] lg:w-[95vw] xl:w-[46vw] justify-around items-end">
            <div className="py-1 px-4 border border-gray-300 rounded">
              <div className="flex items-center space-x-2 cursor-pointer">
                <img
                  src={reduce_icon}
                  alt="reduce_icon"
                  className="h-[20px] w-[20px] mr-2 mt-1 font-bold "
                  onClick={() => setIframeHeight5("16vh")}
                  title="reduce height"
                />
                <img
                  src={reset_icon}
                  alt="reset_icon"
                  className="h-[20px] w-[20px] mr-2 mt-1 font-bold "
                  onClick={() => setIframeHeight5("38vh")}
                  title="reset height"
                />
              </div>
            </div>

            <div className="flex justify-center mt-3 space-x-4">
              <div className="py-1 px-4 border border-gray-300 rounded">
                <div className="flex items-center space-x-2">
                  <HiOutlineZoomIn
                    onClick={zoomIn4}
                    className="cursor-pointer w-6 h-6"
                    title="zoomin"
                  />

                  <HiOutlineZoomOut
                    onClick={zoomOut4}
                    className="cursor-pointer w-6 h-6"
                    title="zoomout"
                  />
                </div>
              </div>
              <button
                onClick={toggleVisibility4}
                className=" px-4 py-1 bg-[#240D3A] text-white rounded hover:bg-[#5a2989] transition"
              >
                {isVisible4 ? "Hide" : "Unhide"}
              </button>
            </div>
          </div>

          {isVisible4 && (
            <div
              className="flex justify-center items-center mt-1 w-[122vw] sm:w-[122vw] md:w-[95vw] lg:w-[95vw] xl:w-[46vw]"
              style={{
                height: iframeHeight5, // Fixed container height
                overflow: "hidden", // Ensure no content spills outside
                position: "relative",
              }}
            >
              <iframe
                title="Uk investing widget"
                src="https://sslecal2.investing.com?columns=exc_flags,exc_currency,exc_importance,exc_actual,exc_forecast,exc_previous&features=datepicker,timezone&countries=25,6,72,22,17,10,35,43,12,4,5&calType=week&timeZone=23&lang=56"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen=""
                className=" block border-[1px]  border-slate-300  sm:border-[0px]  sm:w-[100vw] md:w-[100vw] lg:w-[100vw] xl:w-[46vw] rounded-2xl w-[100%] "
                style={{
                  width: "100%", // Fixed iframe width
                  height: "100%", // Fixed iframe height
                  transform: `scale(${scale4}) translate(${
                    -((scale4 - 1) / scale4) * 50
                  }%, ${-((scale4 - 1) / scale4) * 50}%)`,
                  transformOrigin: "top left", // Anchor zoom at top left
                }}
              ></iframe>
            </div>
          )}
        </div>
      </div>

      <hr
        className="my-6"
        style={{ borderColor: "#240D3A", borderWidth: "1px" }}
      />
      {/* <-----------------widgets dukascopy--------> */}

      {/* <-----widgets links start-----> */}
      <div className="flex justify-around items-center w-full flex-col sm:flex-col md:flex-col lg:flex-col xl:flex-row mt-6"></div>

      <h2 className="text-[#240D3A] flex items-center justify-center text-center font-bold">
        {" "}
        Trading Window{" "}
      </h2>
      <div className="flex justify-center items-center mt-1 w-full ">
        <iframe
          title="Ig page"
          src={iframeSrc}
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen=""
          className=" block   border-[1px]  border-slate-300  sm:border-[0px]  w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[90vw] xl:w-[90vw] rounded-2xl overflow-x-auto"
          style={{ height: "68vh" }}
        ></iframe>
      </div>

      {showModal && (
        <div
          className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-[999] "
          onClick={handleClickOutside}
        >
          <div
            ref={modalRef}
            className="bg-[#efefef] relative rounded-[8px] p-0 sm:p-6 md:p-6 w-[100vw] sm:w-[100vw] md:w-[60vw] lg:md:w-[60vw] xl:md:w-[40vw] max-h-[90vh] overflow-auto"
          >
            <button
              onClick={Closemodal}
              className="absolute top-8 right-8 h-4 w-4 text-gray-600 hover:text-gray-900"
              title="Close"
            >
              {" "}
              <img
                src={crossicon}
                alt="crossicon"
                className="h-[12px] w-[12px]"
              />
            </button>
            <div className="bg-[#f7f7f7] p-6 rounded-[8px]">
              <div className="p-6 max-w-[40rem] mx-auto bg-white rounded-lg shadow-xl mt-4">
                <h2 className="text-xl font-bold mb-4">Update Iframe URL -</h2>
                <input
                  type="text"
                  placeholder="Enter new iframe URL"
                  value={newSrc}
                  onChange={(e) => setNewSrc(e.target.value)}
                  className="w-full border rounded-md p-2 mb-4 focus:outline-none"
                />
                <div className="flex justify-end space-x-2">
                  <button
                    onClick={handleCloseModal}
                    className="px-4 py-1 bg-gray-400 text-white rounded-md"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleSubmit}
                    className="px-4 py-1 bg-[#240D3A] text-white rounded-md hover:bg-[#5a2989]"
                  >
                    Update
                  </button>
                </div>
              </div>

              {/* <--------margin calculatore----------> */}
              <div className="p-6 max-w-[40rem] mx-auto bg-white rounded-lg shadow-xl mt-4">
                {modalloading && (
                  <div className="fixed bottom-0 text-center mb-2 flex items-center justify-end   w-full">
                    <LineWave
                      height="60"
                      width="60"
                      color="#111827"
                      ariaLabel="bars-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={true}
                      className=" w-10 h-10 flex items-center justify-end  mt-10 "
                    />
                  </div>
                )}
                <h1 className="text-[#240D3A] font-bold text-[14px] sm:text-[14px] md:text-[16px] text-[20px] ">
                  Margin Calculator -
                </h1>

                <h2 className="text-[#f48f8f] text-[13px] mb-3 font-semibold">
                  (Please fill all inputs)
                </h2>
                <div className="mb-8 flex items-start sm:items-start md:items-center justify-between flex-col sm:flex-col md:flex-row">
                  <label className="text-md font-bold">Account Currency</label>
                  <select
                    value={accountCurrency}
                    onChange={(e) => setAccountCurrency(e.target.value)}
                    className="border border-gray-300 rounded-md p-2 w-full sm:w-full md:w-[200px]  outline-none"
                  >
                    <option value="">Select Currency</option>
                    {currencies.map((currency) => (
                      <option key={currency} value={currency}>
                        {currency}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="mb-8 flex items-start sm:items-start md:items-center justify-between flex-col sm:flex-col md:flex-row">
                  <label className="text-md font-bold">Margin Ratio</label>
                  <select
                    value={marginRatio}
                    onChange={(e) => setMarginRatio(e.target.value)}
                    className="border border-gray-300 rounded-md p-2 w-full sm:w-full md:w-[200px]   outline-none "
                  >
                    <option value="">Select Ratio</option>
                    {marginRatios.map((ratio) => (
                      <option key={ratio} value={ratio}>
                        {ratio}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-8 flex items-start sm:items-start md:items-center justify-between flex-col sm:flex-col md:flex-row">
                  <label className="w-[300px] sm:w-[300px] md:w-[100%] text-md font-bold">
                    Minimum Lot Size (allowed to trade)
                  </label>
                  <input
                    type="text"
                    value={minimumLotSize}
                    onChange={(e) => setminimumLotSize(e.target.value)}
                    className="border border-gray-300 rounded-md p-2 w-full sm:w-full md:w-[200px]  outline-none"
                    placeholder="Enter lot size"
                  />
                </div>
                <div className="mb-8 flex items-start sm:items-start md:items-center justify-between flex-col sm:flex-col md:flex-row ">
                  <label className="text-md font-bold">Currency Pair</label>
                  <select
                    value={currencyPair}
                    onChange={(e) => setCurrencyPair(e.target.value)}
                    className="border border-gray-300 rounded-md p-2 w-full sm:w-full md:w-[200px]  outline-none relative"
                    dropdownStyle={{
                      maxHeight: "800px",
                      overflowY: "auto", // Adds vertical scrollbar for dropdown options
                    }}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        maxHeight: "400px",
                        overflowY: "auto",
                      }),
                    }}
                  >
                    <option value="">Select Pair</option>
                    {allPairs.map((pair) => (
                      <option key={pair} value={pair}>
                        {pair}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="mb-8 flex items-start sm:items-start md:items-center justify-between flex-col sm:flex-col md:flex-row">
                  <label className="text-md font-bold">Lot Type</label>
                  <select
                    value={lotType}
                    onChange={(e) => setLotType(e.target.value)}
                    className="border border-gray-300 rounded-md p-2 w-full sm:w-full md:w-[200px]  outline-none relative"
                  >
                    <option value="">Select Type</option>
                    {all_lottypes.map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="mb-8 flex items-start sm:items-start md:items-center justify-between flex-col sm:flex-col md:flex-row">
                  <div className=" flex flex-col ">
                    <label className="text-md font-bold">
                      Current Price 1 {`(${currencyPair})`}
                    </label>
                    <span className="text-[#4000ff] text-[14px] pl-3 ">
                      {`(${livetradeTime_forsamecurrency})`}
                    </span>
                  </div>
                  <input
                    type="text"
                    value={currenctprize_forsamecurrency}
                    onChange={(e) =>
                      setCurrenctprize_forsamecurrency(e.target.value)
                    }
                    className="opacity-gray-200 border border-gray-300 rounded-md p-2 w-full sm:w-full md:w-[200px]  outline-none bg-[#ebedef] caret-transparent"
                    placeholder="Enter current price"
                  />
                </div>

                <div className="mb-8 flex items-start sm:items-start md:items-center justify-between flex-col sm:flex-col md:flex-row">
                  <div className=" flex flex-col ">
                    <label className="text-md font-bold">
                      Current Price 2 {`(${getDerivedPair()})`}
                    </label>
                    <span className="text-[#4000ff] text-[14px] pl-3 ">
                      {`(${livetradeTime})`}
                    </span>
                  </div>
                  <input
                    type="text"
                    value={currenctprize}
                    onChange={(e) => setCurrenctprize(e.target.value)}
                    className="opacity-gray-200 border border-gray-300 rounded-md p-2 w-full sm:w-full md:w-[200px]  outline-none bg-[#ebedef] caret-transparent"
                    placeholder="Enter current price"
                  />
                </div>
                <div className="mb-8 flex items-start sm:items-start md:items-center justify-between flex-col sm:flex-col md:flex-row">
                  {/* <label className="text-md font-bold">Trade Size {`(${lotType.split(' (')[0]})`} </label> */}
                  <label className="text-md font-bold">
                    Trade Size {lotType ? `(${lotType.split(" (")[0]})` : ""}
                  </label>

                  <input
                    type="text"
                    value={tradeSize}
                    onChange={(e) => setTradeSize(e.target.value)}
                    className="border border-gray-300 rounded-md p-2 w-full sm:w-full md:w-[200px]  outline-none"
                    placeholder="Enter size"
                  />
                </div>

                <div className="mb-8 flex items-start sm:items-start md:items-center justify-between flex-col sm:flex-col md:flex-row">
                  <label className="text-md font-bold">Currency Units</label>
                  <input
                    type="text"
                    value={currencyUnits}
                    // onChange={(e) => setCurrencyUnits(e.target.value)}
                    readOnly
                    className="bg-[#ebedef] caret-transparent border border-gray-300 rounded-md p-2 w-full sm:w-full md:w-[200px]  outline-none"
                    placeholder="Currency units"
                  />
                </div>
                <hr />
                <div className="mb-4 mt-3 flex items-start sm:items-start md:items-center justify-between flex-col sm:flex-col md:flex-row">
                  <label className="text-md font-bold">Margin Required</label>
                  <input
                    type="text"
                    value={finalmarginvalue}
                    readOnly
                    // onChange={(e) => setFinalmarginvalue(e.target.value)}
                    className="caret-transparent font-bold border border-[#dccafe5e] bg-[#dccafe5e] rounded-md p-2 w-full sm:w-full md:w-[200px]  outline-none"
                    placeholder="Margin value"
                  />
                </div>
                <div className="mb-4 mt-3 flex items-start sm:items-start md:items-center justify-between flex-col sm:flex-col md:flex-row">
                  <label className="text-md font-bold">Pip Value</label>
                  <input
                    type="text"
                    value={finalPipvalue}
                    readOnly
                    // onChange={(e) => setFinalPipvalue(e.target.value)}
                    className="caret-transparent font-bold border border-[#dccafe5e] bg-[#dccafe5e] rounded-md p-2 w-full sm:w-full md:w-[200px]  outline-none"
                    placeholder="Pip value"
                  />
                </div>

                <hr />

                {/* <----new code----> */}
                {/* //portfolio balance */}
                <div className="mb-4 mt-3 flex items-start sm:items-start md:items-center justify-between flex-col sm:flex-col md:flex-row">
                  <label className="text-md font-bold">Balance to trade</label>

                  <div className="relative">
                    <div className="w-[40px] border border-gray-300 absolute inset-y-0 left-0 flex items-center justify-center bg-gray-100 text-gray-600 rounded-l-md">
                      {currencySymbols[accountCurrency] || ""}
                    </div>
                    <input
                      type="text"
                      value={portfolioBalance}
                      onChange={(e) => setPortfolioBalance(e.target.value)}
                      className="border border-gray-300 rounded-md p-2 pl-14 w-[200px]  placeholder:pl-0 outline-none"
                      placeholder="Portfolio Balance"
                    />
                  </div>
                </div>
                <div className="mb-8 flex items-start sm:items-start md:items-center justify-between flex-col sm:flex-col md:flex-row">
                  <label className="text-md font-bold">Profit Target (%)</label>
                  <input
                    type="text"
                    value={profitTarget}
                    onChange={(e) => setprofitTarget(e.target.value)}
                    className="border border-gray-300 rounded-md p-2 w-full sm:w-full md:w-[200px]  outline-none"
                    placeholder="Profit Target %"
                  />
                </div>
                <div className="mb-8 flex items-start sm:items-start md:items-center justify-between flex-col sm:flex-col md:flex-row">
                  <label className="text-md font-bold">Loss Limit (%)</label>
                  <input
                    type="text"
                    value={lossLimit}
                    onChange={(e) => setlossLimit(e.target.value)}
                    className=" appearance-none border border-gray-300 rounded-md p-2 w-full sm:w-full md:w-[200px]  outline-none"
                    placeholder="Loss Limit %"
                  />
                </div>

                {/* //max tradelot */}
                <div className="mb-4 mt-3 flex items-start sm:items-start md:items-center justify-between flex-col sm:flex-col md:flex-row">
                  <label className="text-md font-bold">Max tradable lots</label>
                  <input
                    type="text"
                    value={maxLots}
                    readOnly
                    // onChange={(e) => setMaxLots(e.target.value)}
                    className="bg-[#ebedef] caret-transparent border border-gray-300 rounded-md p-2 w-full sm:w-full md:w-[200px]  outline-none"
                    placeholder="Max Lots"
                  />
                </div>

                <div className="mb-8 flex items-start sm:items-start md:items-center justify-between flex-col sm:flex-col md:flex-row">
                  <label className="text-md font-bold">
                    Profit Target Pips
                  </label>
                  <input
                    type="text"
                    value={profitTargetPips}
                    readOnly
                    // onChange={(e) => setprofitTargetPips(e.target.value)}
                    className="bg-[#ebedef] caret-transparent border border-gray-300 rounded-md p-2 w-full sm:w-full md:w-[200px]  outline-none"
                    placeholder="Profit Target Pips"
                  />
                </div>

                <div className="mb-8 flex items-start sm:items-start md:items-center justify-between flex-col sm:flex-col md:flex-row">
                  <label className="text-md font-bold">Loss Limit Pips</label>
                  <input
                    type="text"
                    value={lossLimitPips}
                    readOnly
                    // onChange={(e) => setlossLimitPips(e.target.value)}
                    className="bg-[#ebedef] caret-transparent border border-gray-300 rounded-md p-2 w-full sm:w-full md:w-[200px]  outline-none"
                    placeholder="Loss Limit Pips"
                  />
                </div>

                <button
                  onClick={handleCalculate}
                  className="mt-4 w-full bg-[#240D3A] text-white py-2 px-4 rounded-md hover:bg-[#5a2989]"
                >
                  Calculate
                </button>
              </div>
            </div>

            {/* <-----------pip calculator-----------> */}
          </div>
        </div>
      )}
    </>
  );
};

export default Userbuysell;
